import { Component, OnDestroy, OnInit, } from '@angular/core';
import { MediaChange, MediaObserver } from "@angular/flex-layout";
import { Subscription } from 'rxjs';
import { menu } from './ui/model/menu';
import { AuthenticationService } from '../components/login/authentication.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Reports } from '../popupmodal/tabaccesmodal/modal/reportTab';
import { NCCF } from '../popupmodal/tabaccesmodal/modal/NCCFtab';

@Component({
  selector: 'app-features',
  templateUrl: './features.component.html',
  styleUrls: ['./features.component.css']
})
export class FeaturesComponent implements OnInit, OnDestroy {

    public opened: boolean = true;
    private mediaWatcher: Subscription;
    status: boolean;
    statusLink: boolean;
    isHovering: boolean;
    currentUser: any;
    role: any;
    mymennu = menu;
    reportTab = Reports;
    NccfTab = NCCF;

    constructor(private media : MediaObserver,
                private authenticate: AuthenticationService,
                private _activatedRoute : ActivatedRoute,
                private router : Router,
                private _tostr : ToastrService) {

                  this.authenticate.currentUser.subscribe(x => this.currentUser = x);
                  // this.mediaWatcher = this.media.media$.subscribe((mediaChange: MediaChange) => {
                  //   this.handleMediaChange(mediaChange);
                  // })
    }

    ngOnInit() {
      this.authenticate.isLoggedIn
      this.role = this.currentUser.isUser;
      this.verifyUSer(this.currentUser.tabName)
    }

    verifyUSer(tabs){
        var parameterValue = this._activatedRoute.snapshot['_routerState'].url;
        const url = parameterValue.replace('/', '');
        var allwedUrl = this.currentUser.tabName.find(x => x.toLowerCase() == url);
        if(allwedUrl == undefined){
          this.router.navigate(['/login'])
        }
      if(this.currentUser.isUser !== 'Admin'){
        this.mymennu.forEach(element => {
          element.isActive = 0
          if(element.children){
            element.children.forEach(element2 => {
              element2.isActive = 0
            });
          }
        });
        for(let i = 0; this.mymennu.length > i; i++){
          for(let j = 0; tabs.length > j; j++){
            if(this.mymennu[i].displayName == tabs[j]){
              this.mymennu[i].isActive = 1
            }
          }
        }
        
        var existReport = tabs.find(x => x == 'Report')
        if(existReport){
          this.reportTab.forEach(element => {
            if(element?.label == tabs.find(x => x == element?.label)){
              var data = this.mymennu.find(x => x.displayName == 'Report')
              if(data){
                var exist = data.children.find(x => x.displayName == element?.label)
                if(exist){
                  exist.isActive = 1
                }
              }
            }
          });
        }
  
        var existNccf = tabs.find(x => x == 'NCCF')
        if(existNccf){
          this.NccfTab.forEach(element => {
            if(element?.label == tabs.find(x => x == element?.label)){
              var data = this.mymennu.find(x => x.displayName == 'NCCF')
              if(data){
                var exist = data.children.find(x => x.displayName == element?.label)
                if(exist){
                  exist.isActive = 1
                }
              }
            }
          });
        }
      }else{
        this.mymennu.forEach(element => {
          element.isActive = 1
          if(element.children){
            element.children.forEach(element2 => {
              element2.isActive = 1
            });
          }
        });
      }
    
    }

    private handleMediaChange(mediaChange: MediaChange) {
        if (this.media.isActive('lt-md')) {
            this.opened = false;
        } else {
            this.opened = true;
        }
    }

    ngOnDestroy() {
        // this.mediaWatcher.unsubscribe();
    }

    onMouseEnter($event) {
      console.log('onMouseEnter');
      this.isHovering = true;
    }
  
    onMouseLeave($event) {
      console.log('onMouseLeave');
      this.isHovering = false;
    }
    
    clickEvent() {
      this.status = !this.status;    
    }

    logout(){
      this.authenticate.logout()
    }
}
